import { Component } from '@angular/core';
import { CIPXDrawerComponent } from './drawer.component';

@Component({
  selector: 'cipx-vertical-drawer',
  template: '', // Inherits template from parent
  standalone: true,
})
export class CIPXVerticalDrawerComponent extends CIPXDrawerComponent {
  // Placeholder for future vertical-specific functionality
  // Currently adds nothing to the base drawer
}
